((doc,win)=>{
    const docEl = doc.documentElement,
        recalc = () => {
            let clientWidth = docEl.clientWidth;
            docEl.style.fontSize = (clientWidth / 1920) * 100 + "px";
        };
    if(doc.addEventListener){
        doc.addEventListener("DOMContentLoaded", recalc, !1);
        win.addEventListener("resize", recalc, !1);
    }
})(document,window)